import { useState, useCallback } from "react";
import service from "commons/apis";

const useGetAreaForProject = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const refetch = useCallback(async (projectId) => {
    if (!projectId) {
      setData([]);
      return [];
    }

    try {
      setLoading(true);
      const { items } = await service.getAreas({ projectId });
      setData(items);
      return items;
    } catch (error) {
      console.error("Fetch areas error:", error);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    data,
    loading,
    refetch,
  };
};

export default useGetAreaForProject;
